
import React, {useRef} from 'react';
import {useIsMobile} from "../../../../hooks/useIsMobile";
import {motion, useInView} from "framer-motion";

const LikeFollowSection: React.FC = () => {
    const isMobile = useIsMobile();
    const ref = useRef(null);
    const isInView = useInView(ref, {once: true, margin: "-100px"});


    return (

        <>


            <div className={"flex flex-col md:gap-[30px]"}>

            {isMobile && (

                <motion.div
                    ref={ref}
                    className="flex flex-col gap-3 text-center"
                    initial={{opacity: 0, y: 20}}
                    animate={isInView ? {opacity: 1, y: 0} : {}}
                    transition={{duration: 0.6, delay: 0}}
                >
                    <h2 className="text-[36px] md:text-[22px] md:leading-[28px] font-extrabold  text-[#111827]">
                        좋아요, 팔로우 시스템으로 <br className="hidden md:block"/> 연결되는 특별한 만남
                    </h2>

                    <motion.span
                        ref={ref}
                        className="text-[20px] md:text-base md:leading-[22px] text-[#6C7B7F] font-normal"
                        initial={{opacity: 0, y: 20}}
                        animate={isInView ? {opacity: 1, y: 0} : {}}
                        transition={{duration: 0.6, delay: 0.2}}
                    >
                        팔로우와 좋아요 기능을 통해 <br className="hidden md:block"/> 작가와 독자가 서로 소통할 수 있어요.
                    </motion.span>

                </motion.div>


            )}


            <section className="py-16 px-4 flex flex-col gap-[64px] "
                     style={{
                         background: 'linear-gradient(135deg, #F5F5F5 0%, rgba(25, 207, 122, 0.3) 60%, rgba(25, 207, 122, 0.05) 100%)'
                     }}
            >

                {!isMobile && (
                    <motion.div
                        ref={ref}
                        className="flex flex-col gap-3 text-center mx-auto"
                        initial={{opacity: 0, y: 20}}
                        animate={isInView ? {opacity: 1, y: 0} : {}}
                        transition={{duration: 0.6, delay: 0}}
                    >
                        <h2 className="text-[36px] md:text-[22px] md:leading-[28px] font-extrabold  text-[#111827]">
                            좋아요, 팔로우 시스템으로 <br className="hidden md:block"/> 연결되는 특별한 만남
                        </h2>


                        <motion.span
                            ref={ref}
                            className="text-[20px] md:text-base md:leading-[22px] text-[#6C7B7F] font-normal"
                            initial={{opacity: 0, y: 20}}
                            animate={isInView ? {opacity: 1, y: 0} : {}}
                            transition={{duration: 0.6, delay: 0.2}}
                        >
                            팔로우와 좋아요 기능을 통해 <br className="hidden md:block"/> 작가와 독자가 서로 소통할 수 있어요.
                        </motion.span>

                    </motion.div>
                )}

                {isMobile ? (

                        <motion.div
                            ref={ref}
                            initial={{opacity: 0}}
                            animate={isInView ? {opacity: 1, y: 0} : {}}
                            transition={{duration: 0.5, delay: 0.4, ease: 'easeOut',}}
                            className="flex flex-col gap-5 "
                        >
                            <div
                                style={{
                                    borderRadius: '24px',
                                    border: '1px solid rgba(25, 207, 122, 0.10)',
                                    background: '#FFF',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.10), 0 10px 15px rgba(0, 0, 0, 0.10)',
                                }}
                                className="flex w-full h-[220px] flex-col gap-2 p-3 overflow-hidden"
                            >
                                <div className={"flex flex-row gap-2"}>
                                    <div className="flex justify-center items-center">
                                        <div
                                            className={"flex w-[48px] h-[48px] md:w-[37px] md:h-[37px] justify-center items-center rounded-full bg-[#19CF7A1A]"}>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24"
                                                 viewBox="0 0 30 24" fill="none" className="md:w-[16px] md:h-[14px]">
                                                <g clip-path="url(#clip0_4962_10695)">
                                                    <path
                                                        d="M4.5 6C4.5 4.4087 5.13214 2.88258 6.25736 1.75736C7.38258 0.632141 8.9087 0 10.5 0C12.0913 0 13.6174 0.632141 14.7426 1.75736C15.8679 2.88258 16.5 4.4087 16.5 6C16.5 7.5913 15.8679 9.11742 14.7426 10.2426C13.6174 11.3679 12.0913 12 10.5 12C8.9087 12 7.38258 11.3679 6.25736 10.2426C5.13214 9.11742 4.5 7.5913 4.5 6ZM0 22.6078C0 17.9906 3.74063 14.25 8.35781 14.25H12.6422C17.2594 14.25 21 17.9906 21 22.6078C21 23.3766 20.3766 24 19.6078 24H1.39219C0.623438 24 0 23.3766 0 22.6078ZM23.625 14.625V11.625H20.625C20.0016 11.625 19.5 11.1234 19.5 10.5C19.5 9.87656 20.0016 9.375 20.625 9.375H23.625V6.375C23.625 5.75156 24.1266 5.25 24.75 5.25C25.3734 5.25 25.875 5.75156 25.875 6.375V9.375H28.875C29.4984 9.375 30 9.87656 30 10.5C30 11.1234 29.4984 11.625 28.875 11.625H25.875V14.625C25.875 15.2484 25.3734 15.75 24.75 15.75C24.1266 15.75 23.625 15.2484 23.625 14.625Z"
                                                        fill="#19CF7A"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4962_10695">
                                                        <path d="M0 0H30V24H0V0Z" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>

                                    <div className={"flex flex-col justify-center gap-1"}>
                                        <span className={"text-xl md:text-sm text-[#111827] font-bold leading-6"}>
                                            팔로우 시스템
                                        </span>
                                        <span className={"text-sm md:text-xs text-[#6C7B7F] font-medium leading-4"}>
                좋아하는 작가를 팔로우하고, 언제든 다시 찾아보세요!
            </span>
                                    </div>

                                </div>

                                <div
                                    className={"flex w-full h-[70px] justify-between gap-4 bg-[#F5F5F5] rounded-[12px] px-2 py-1"}>
                                    <div className={"flex flex-row justify-center items-center gap-2"}>
                                        <div
                                            className="flex justify-center flex-shrink-0 items-center w-[32px] h-[32px] md:w-[28px] md:h-[28px] rounded-full">
                                            <img className="w-full h-full rounded-full object-cover "
                                                 src="/img/home/author1.jpg"
                                                 alt="작가 이미지"/>
                                        </div>

                                        <div className={"flex flex-col gap-0.5 justify-center"}>
                                            <span
                                                className={"text-[#111827] text-sm md:text-xs font-[600] leading-4"}>오지안</span>
                                            <span className={"text-xs text-[#6C7B7F] md:text-xs font-medium leading-4"}>「물고기의 꿈」,「하늘을 나는 씨앗」</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center justify-center"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16"
                                             fill="none" className="md:w-[16px] md:h-[14px]">
                                            <g clip-path="url(#clip0_4962_10711)">
                                                <path
                                                    d="M3.67188 4C3.67188 2.93913 4.0933 1.92172 4.84345 1.17157C5.59359 0.421427 6.61101 0 7.67188 0C8.73274 0 9.75016 0.421427 10.5003 1.17157C11.2504 1.92172 11.6719 2.93913 11.6719 4C11.6719 5.06087 11.2504 6.07828 10.5003 6.82843C9.75016 7.57857 8.73274 8 7.67188 8C6.61101 8 5.59359 7.57857 4.84345 6.82843C4.0933 6.07828 3.67188 5.06087 3.67188 4ZM0.671875 15.0719C0.671875 11.9937 3.16563 9.5 6.24375 9.5H9.1C12.1781 9.5 14.6719 11.9937 14.6719 15.0719C14.6719 15.5844 14.2562 16 13.7437 16H1.6C1.0875 16 0.671875 15.5844 0.671875 15.0719ZM16.4219 9.75V7.75H14.4219C14.0063 7.75 13.6719 7.41563 13.6719 7C13.6719 6.58437 14.0063 6.25 14.4219 6.25H16.4219V4.25C16.4219 3.83437 16.7563 3.5 17.1719 3.5C17.5875 3.5 17.9219 3.83437 17.9219 4.25V6.25H19.9219C20.3375 6.25 20.6719 6.58437 20.6719 7C20.6719 7.41563 20.3375 7.75 19.9219 7.75H17.9219V9.75C17.9219 10.1656 17.5875 10.5 17.1719 10.5C16.7563 10.5 16.4219 10.1656 16.4219 9.75Z"
                                                    fill="#19CF7A"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10711">
                                                    <path d="M0.671875 0H20.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span className={"text-main text-sm md:text-xs font-bold leading-none"}>410</span>

                                    </div>
                                </div>

                                {/* 3. 두 번째 작가 정보 섹션 */}
                                <div
                                    className={"flex w-full h-[53px] justify-between gap-4 bg-[#F5F5F5] rounded-[12px] px-2 py-1"}>
                                    <div className={"flex flex-row justify-center items-center gap-2"}>
                                        <div
                                            className="flex justify-center flex-shrink-0 items-center w-[32px] h-[32px]  md:w-[28px] md:h-[28px] rounded-full">
                                            <img className="w-full h-full rounded-full object-cover "
                                                 src="/img/home/author2.jpg"
                                                 alt="작가 이미지"/>
                                        </div>

                                        <div className={"flex flex-col gap-0 justify-center"}>
                                            <span
                                                className={"text-[#111827] text-sm md:text-xs font-[600] leading-4"}>김시우</span>
                                            <span className={"text-xs text-[#6C7B7F]  md:text-xs  font-medium leading-4"}>「마음의 정리법」,「오늘을 사는 기술」</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center justify-center"}>
                                        {/* SVG 코드는 변경 없음 */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16"
                                             fill="none" className="md:w-[16px] md:h-[14px]">
                                            <g clip-path="url(#clip0_4962_10711)">
                                                <path
                                                    d="M3.67188 4C3.67188 2.93913 4.0933 1.92172 4.84345 1.17157C5.59359 0.421427 6.61101 0 7.67188 0C8.73274 0 9.75016 0.421427 10.5003 1.17157C11.2504 1.92172 11.6719 2.93913 11.6719 4C11.6719 5.06087 11.2504 6.07828 10.5003 6.82843C9.75016 7.57857 8.73274 8 7.67188 8C6.61101 8 5.59359 7.57857 4.84345 6.82843C4.0933 6.07828 3.67188 5.06087 3.67188 4ZM0.671875 15.0719C0.671875 11.9937 3.16563 9.5 6.24375 9.5H9.1C12.1781 9.5 14.6719 11.9937 14.6719 15.0719C14.6719 15.5844 14.2562 16 13.7437 16H1.6C1.0875 16 0.671875 15.5844 0.671875 15.0719ZM16.4219 9.75V7.75H14.4219C14.0063 7.75 13.6719 7.41563 13.6719 7C13.6719 6.58437 14.0063 6.25 14.4219 6.25H16.4219V4.25C16.4219 3.83437 16.7563 3.5 17.1719 3.5C17.5875 3.5 17.9219 3.83437 17.9219 4.25V6.25H19.9219C20.3375 6.25 20.6719 6.58437 20.6719 7C20.6719 7.41563 20.3375 7.75 19.9219 7.75H17.9219V9.75C17.9219 10.1656 17.5875 10.5 17.1719 10.5C16.7563 10.5 16.4219 10.1656 16.4219 9.75Z"
                                                    fill="#19CF7A"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10711">
                                                    <path d="M0.671875 0H20.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span className={"text-main text-sm font-bold md:text-xs leading-4"}>681</span>

                                    </div>


                                </div>

                            </div>


                            <div
                                style={{
                                    borderRadius: '24px',
                                    border: '1px solid rgba(25, 207, 122, 0.10)',
                                    background: '#FFF',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.10), 0 10px 15px rgba(0, 0, 0, 0.10)',
                                }}
                                className="flex w-full h-[196px] flex-col gap-2 p-3 overflow-hidden"
                            >
                                <div className={"flex flex-row gap-2"}>
                                    <div className="flex justify-center items-center">
                                        <div
                                            className={"flex w-[64px] h-[64px] md:w-[37px] md:h-[37px] justify-center items-center rounded-full bg-[#FEE2E2]"}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 viewBox="0 0 24 24" fill="none" className={"w-5 h-4"}>
                                                <path
                                                    d="M2.23125 14.081L10.7016 21.9888C11.0531 22.317 11.5172 22.4998 12 22.4998C12.4828 22.4998 12.9469 22.317 13.2984 21.9888L21.7687 14.081C23.1938 12.7545 24 10.8935 24 8.9482V8.67633C24 5.39976 21.6328 2.60601 18.4031 2.06695C16.2656 1.7107 14.0906 2.40914 12.5625 3.93726L12 4.49976L11.4375 3.93726C9.90938 2.40914 7.73438 1.7107 5.59688 2.06695C2.36719 2.60601 0 5.39976 0 8.67633V8.9482C0 10.8935 0.80625 12.7545 2.23125 14.081Z"
                                                    fill="#DC2626"/>
                                            </svg>
                                        </div>
                                    </div>

                                    <div className={"flex flex-col justify-center gap-1"}>
                                        <span className={"text-xl md:text-sm text-[#111827] font-bold leading-6"}>
                                            좋아요 시스템
                                        </span>
                                        <span className={"text-sm md:text-xs text-[#6C7B7F] font-medium leading-4"}>
              작품과 엽서에 대한 독자들의 반응을 확인하세요!
            </span>
                                    </div>

                                </div>

                                <div
                                    className={"flex w-full h-[53px] justify-between gap-4 bg-[#F5F5F5] rounded-[12px] px-2 py-1"}>
                                    <div className={"flex flex-row justify-center items-center gap-2"}>
                                        <div
                                            className="flex justify-center items-center w-[40px] h-[40px]  md:w-7 md:h-7 md:p-[6px] bg-[#EF4444] rounded-full">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16"
                                                 viewBox="0 0 14 16" fill="none" className={"md:w-3 h-3"}>
                                                <g clip-path="url(#clip0_4962_10743)">
                                                    <path
                                                        d="M3 0C1.34375 0 0 1.34375 0 3V13C0 14.6562 1.34375 16 3 16H12H13C13.5531 16 14 15.5531 14 15C14 14.4469 13.5531 14 13 14V12C13.5531 12 14 11.5531 14 11V1C14 0.446875 13.5531 0 13 0H12H3ZM3 12H11V14H3C2.44688 14 2 13.5531 2 13C2 12.4469 2.44688 12 3 12ZM4 4.5C4 4.225 4.225 4 4.5 4H10.5C10.775 4 11 4.225 11 4.5C11 4.775 10.775 5 10.5 5H4.5C4.225 5 4 4.775 4 4.5ZM4.5 6H10.5C10.775 6 11 6.225 11 6.5C11 6.775 10.775 7 10.5 7H4.5C4.225 7 4 6.775 4 6.5C4 6.225 4.225 6 4.5 6Z"
                                                        fill="white"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4962_10743">
                                                        <path d="M0 0H14V16H0V0Z" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>

                                        <div className={"flex flex-col gap-1 justify-center"}>
                                            <span className={"text-[#111827] text-base md:text-sm font-[600]"}>작품</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center justify-center "}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16"
                                             fill="none" className={"md:w-3 h-3"}>
                                            <g clip-path="url(#clip0_4962_10765)">
                                                <path
                                                    d="M2.15937 9.38767L7.80625 14.6595C8.04063 14.8783 8.35 15.0002 8.67188 15.0002C8.99375 15.0002 9.30313 14.8783 9.5375 14.6595L15.1844 9.38767C16.1344 8.50329 16.6719 7.26267 16.6719 5.96579V5.78454C16.6719 3.60017 15.0938 1.73767 12.9406 1.37829C11.5156 1.14079 10.0656 1.60642 9.04688 2.62517L8.67188 3.00017L8.29688 2.62517C7.27812 1.60642 5.82812 1.14079 4.40313 1.37829C2.25 1.73767 0.671875 3.60017 0.671875 5.78454V5.96579C0.671875 7.26267 1.20937 8.50329 2.15937 9.38767Z"
                                                    fill="#EF4444"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10765">
                                                    <path d="M0.671875 0H16.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span
                                            className={"text-[#DC2626] text-base md:text-xs font-bold leading-6"}>1,247</span>

                                    </div>
                                </div>

                                <div
                                    className={"flex w-full h-[53px] justify-between gap-4 bg-[#F5F5F5] rounded-[12px] px-2 py-1"}>
                                    <div className={"flex flex-row justify-center items-center gap-2"}>
                                        <div
                                            className="flex justify-center items-center w-[40px] h-[40px] md:w-7 md:h-7 md:p-[6px] bg-main rounded-full">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                 viewBox="0 0 16 16" fill="none" className={"md:w-3 h-3"}>
                                                <path d="M16 16H0V0H16V16Z" stroke="#E5E7EB"/>
                                                <path
                                                    d="M0 3C0 1.89688 0.896875 1 2 1H14C15.1031 1 16 1.89688 16 3V13C16 14.1031 15.1031 15 14 15H2C0.896875 15 0 14.1031 0 13V3ZM10.1187 6.32812C9.97812 6.12187 9.74687 6 9.5 6C9.25313 6 9.01875 6.12187 8.88125 6.32812L6.1625 10.3156L5.33437 9.28125C5.19062 9.10312 4.975 9 4.75 9C4.525 9 4.30625 9.10312 4.16563 9.28125L2.16563 11.7812C1.98438 12.0063 1.95 12.3156 2.075 12.575C2.2 12.8344 2.4625 13 2.75 13H5.75H6.75H13.25C13.5281 13 13.7844 12.8469 13.9125 12.6C14.0406 12.3531 14.025 12.0562 13.8687 11.8281L10.1187 6.32812ZM3.5 6C3.89782 6 4.27936 5.84196 4.56066 5.56066C4.84196 5.27936 5 4.89782 5 4.5C5 4.10218 4.84196 3.72064 4.56066 3.43934C4.27936 3.15804 3.89782 3 3.5 3C3.10218 3 2.72064 3.15804 2.43934 3.43934C2.15804 3.72064 2 4.10218 2 4.5C2 4.89782 2.15804 5.27936 2.43934 5.56066C2.72064 5.84196 3.10218 6 3.5 6Z"
                                                    fill="white"/>
                                            </svg>
                                        </div>

                                        <div className={"flex flex-col gap-1 justify-center"}>
                                            <span className={"text-[#111827] text-base md:text-sm  font-[600]"}>엽서</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center justify-center "}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16"
                                             fill="none" className={"md:w-3 h-3"}>
                                            <g clip-path="url(#clip0_4962_10765)">
                                                <path
                                                    d="M2.15937 9.38767L7.80625 14.6595C8.04063 14.8783 8.35 15.0002 8.67188 15.0002C8.99375 15.0002 9.30313 14.8783 9.5375 14.6595L15.1844 9.38767C16.1344 8.50329 16.6719 7.26267 16.6719 5.96579V5.78454C16.6719 3.60017 15.0938 1.73767 12.9406 1.37829C11.5156 1.14079 10.0656 1.60642 9.04688 2.62517L8.67188 3.00017L8.29688 2.62517C7.27812 1.60642 5.82812 1.14079 4.40313 1.37829C2.25 1.73767 0.671875 3.60017 0.671875 5.78454V5.96579C0.671875 7.26267 1.20937 8.50329 2.15937 9.38767Z"
                                                    fill="#EF4444"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10765">
                                                    <path d="M0.671875 0H16.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span
                                            className={"text-[#DC2626] text-base font-bold md:text-xs leading-6"}>389</span>


                                    </div>


                                </div>

                            </div>


                        </motion.div>


                    )


                    :


                    (


                        <motion.div
                            ref={ref}
                            initial={{opacity: 0}}
                            animate={isInView ? {opacity: 1, y: 0} : {}}
                            transition={{duration: 0.5, delay: 0.4, ease: 'easeOut',}}
                            className="max-w-6xl mx-auto flex gap-[47px] md:flex-col"
                        >
                            <div
                                style={{
                                    borderRadius: '24px',
                                    border: '1px solid rgba(25, 207, 122, 0.10)',
                                    background: '#FFF',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.10), 0 10px 15px rgba(0, 0, 0, 0.10)',
                                }}
                                className="flex w-[592px] md:w-full md:h-full flex-col p-8 gap-8 md:p-6"
                            >
                                <div className={"flex flex-row gap-4 "}>
                                    <div className="flex justify-center items-center">
                                        <div
                                            className={"flex w-[64px] h-[64px] md:w-[37px] md:h-[37px] justify-center items-center rounded-full bg-[#19CF7A1A]"}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24"
                                                 viewBox="0 0 30 24" fill="none" className="md:w-[16px] md:h-[14px]">
                                                <g clip-path="url(#clip0_4962_10695)">
                                                    <path
                                                        d="M4.5 6C4.5 4.4087 5.13214 2.88258 6.25736 1.75736C7.38258 0.632141 8.9087 0 10.5 0C12.0913 0 13.6174 0.632141 14.7426 1.75736C15.8679 2.88258 16.5 4.4087 16.5 6C16.5 7.5913 15.8679 9.11742 14.7426 10.2426C13.6174 11.3679 12.0913 12 10.5 12C8.9087 12 7.38258 11.3679 6.25736 10.2426C5.13214 9.11742 4.5 7.5913 4.5 6ZM0 22.6078C0 17.9906 3.74063 14.25 8.35781 14.25H12.6422C17.2594 14.25 21 17.9906 21 22.6078C21 23.3766 20.3766 24 19.6078 24H1.39219C0.623438 24 0 23.3766 0 22.6078ZM23.625 14.625V11.625H20.625C20.0016 11.625 19.5 11.1234 19.5 10.5C19.5 9.87656 20.0016 9.375 20.625 9.375H23.625V6.375C23.625 5.75156 24.1266 5.25 24.75 5.25C25.3734 5.25 25.875 5.75156 25.875 6.375V9.375H28.875C29.4984 9.375 30 9.87656 30 10.5C30 11.1234 29.4984 11.625 28.875 11.625H25.875V14.625C25.875 15.2484 25.3734 15.75 24.75 15.75C24.1266 15.75 23.625 15.2484 23.625 14.625Z"
                                                        fill="#19CF7A"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4962_10695">
                                                        <path d="M0 0H30V24H0V0Z" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>

                                    <div className={"flex flex-col justify-center"}>
                                        <h2 className={"text-2xl md:text-sm text-[#111827] font-bold leading-8"}>
                                            팔로우 시스템
                                        </h2>
                                        <span className={"text-base md:text-xs text-[#6C7B7F] font-medium leading-6"}>
                                좋아하는 작가를 팔로우하고, 언제든 편히 다시 찾아보세요.</span>
                                    </div>

                                </div>

                                <div className={"flex  justify-between gap-4 bg-[#F5F5F5] rounded-[12px]  p-4 md:p-3 "}>
                                    <div className={"flex flex-row justify-center items-center gap-3 "}>
                                        <div
                                            className="flex justify-center flex-shrink-0 items-center w-[40px] h-[40px] md:w-[28px] md:h-[28px] rounded-full">
                                            <img className="w-full h-full rounded-full object-cover "
                                                 src="/img/home/author1.jpg"
                                                 alt="작가 이미지"/>
                                        </div>

                                        <div className={"flex flex-col gap-1 justify-center"}>
                                            <span
                                                className={"text-[#111827] text-base md:text-sm font-[600]"}>오지안</span>
                                            <span
                                                className={"text-sm text-[#6C7B7F] md:text-xs font-medium leading-normal"}>「물고기의 꿈」, 「하늘을 나는 씨앗」</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center justify-center"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16"
                                             viewBox="0 0 21 16" fill="none" className="md:w-[16px] md:h-[14px]">
                                            <g clip-path="url(#clip0_4962_10711)">
                                                <path
                                                    d="M3.67188 4C3.67188 2.93913 4.0933 1.92172 4.84345 1.17157C5.59359 0.421427 6.61101 0 7.67188 0C8.73274 0 9.75016 0.421427 10.5003 1.17157C11.2504 1.92172 11.6719 2.93913 11.6719 4C11.6719 5.06087 11.2504 6.07828 10.5003 6.82843C9.75016 7.57857 8.73274 8 7.67188 8C6.61101 8 5.59359 7.57857 4.84345 6.82843C4.0933 6.07828 3.67188 5.06087 3.67188 4ZM0.671875 15.0719C0.671875 11.9937 3.16563 9.5 6.24375 9.5H9.1C12.1781 9.5 14.6719 11.9937 14.6719 15.0719C14.6719 15.5844 14.2562 16 13.7437 16H1.6C1.0875 16 0.671875 15.5844 0.671875 15.0719ZM16.4219 9.75V7.75H14.4219C14.0063 7.75 13.6719 7.41563 13.6719 7C13.6719 6.58437 14.0063 6.25 14.4219 6.25H16.4219V4.25C16.4219 3.83437 16.7563 3.5 17.1719 3.5C17.5875 3.5 17.9219 3.83437 17.9219 4.25V6.25H19.9219C20.3375 6.25 20.6719 6.58437 20.6719 7C20.6719 7.41563 20.3375 7.75 19.9219 7.75H17.9219V9.75C17.9219 10.1656 17.5875 10.5 17.1719 10.5C16.7563 10.5 16.4219 10.1656 16.4219 9.75Z"
                                                    fill="#19CF7A"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10711">
                                                    <path d="M0.671875 0H20.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span
                                            className={"text-main text-base md:text-xs font-bold leading-6"}>410</span>


                                    </div>


                                </div>


                                <div className={"flex justify-between gap-4 bg-[#F5F5F5] rounded-[12px] p-4 md:p-2 "}>
                                    <div className={"flex flex-row justify-center items-center gap-3"}>
                                        <div
                                            className="flex justify-center flex-shrink-0 items-center w-[40px] h-[40px]  md:w-[28px] md:h-[28px] rounded-full">
                                            <img className="w-full h-full rounded-full object-cover "
                                                 src="/img/home/author2.jpg"
                                                 alt="작가 이미지"/>
                                        </div>

                                        <div className={"flex flex-col gap-1 justify-center"}>
                                            <span
                                                className={"text-[#111827] text-base md:text-sm font-[600]"}>김시우</span>
                                            <span
                                                className={"text-sm text-[#6C7B7F]  md:text-xs  font-medium leading-normal"}>「마음의 정리법」, 「오늘을 사는 기술」</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center justify-center"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16"
                                             viewBox="0 0 21 16" fill="none" className="md:w-[16px] md:h-[14px]">
                                            <g clip-path="url(#clip0_4962_10711)">
                                                <path
                                                    d="M3.67188 4C3.67188 2.93913 4.0933 1.92172 4.84345 1.17157C5.59359 0.421427 6.61101 0 7.67188 0C8.73274 0 9.75016 0.421427 10.5003 1.17157C11.2504 1.92172 11.6719 2.93913 11.6719 4C11.6719 5.06087 11.2504 6.07828 10.5003 6.82843C9.75016 7.57857 8.73274 8 7.67188 8C6.61101 8 5.59359 7.57857 4.84345 6.82843C4.0933 6.07828 3.67188 5.06087 3.67188 4ZM0.671875 15.0719C0.671875 11.9937 3.16563 9.5 6.24375 9.5H9.1C12.1781 9.5 14.6719 11.9937 14.6719 15.0719C14.6719 15.5844 14.2562 16 13.7437 16H1.6C1.0875 16 0.671875 15.5844 0.671875 15.0719ZM16.4219 9.75V7.75H14.4219C14.0063 7.75 13.6719 7.41563 13.6719 7C13.6719 6.58437 14.0063 6.25 14.4219 6.25H16.4219V4.25C16.4219 3.83437 16.7563 3.5 17.1719 3.5C17.5875 3.5 17.9219 3.83437 17.9219 4.25V6.25H19.9219C20.3375 6.25 20.6719 6.58437 20.6719 7C20.6719 7.41563 20.3375 7.75 19.9219 7.75H17.9219V9.75C17.9219 10.1656 17.5875 10.5 17.1719 10.5C16.7563 10.5 16.4219 10.1656 16.4219 9.75Z"
                                                    fill="#19CF7A"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10711">
                                                    <path d="M0.671875 0H20.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span
                                            className={"text-main text-base font-bold md:text-xs  leading-6"}>681</span>

                                    </div>

                                </div>

                            </div>

                            <div
                                style={{
                                    borderRadius: '24px',
                                    border: '1px solid rgba(25, 207, 122, 0.10)',
                                    background: '#FFF',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.10), 0 10px 15px rgba(0, 0, 0, 0.10)',
                                }}
                                className="flex w-[592px] md:w-full md:h-full flex-col p-8 gap-8  md:p-6"
                            >

                                <div className={"flex flex-row gap-4 "}>
                                    <div className="flex justify-center items-center">
                                        <div
                                            className={"flex w-[64px] h-[64px] md:w-[37px] md:h-[37px] justify-center items-center rounded-full bg-[#FEE2E2]"}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M2.23125 14.081L10.7016 21.9888C11.0531 22.317 11.5172 22.4998 12 22.4998C12.4828 22.4998 12.9469 22.317 13.2984 21.9888L21.7687 14.081C23.1938 12.7545 24 10.8935 24 8.9482V8.67633C24 5.39976 21.6328 2.60601 18.4031 2.06695C16.2656 1.7107 14.0906 2.40914 12.5625 3.93726L12 4.49976L11.4375 3.93726C9.90938 2.40914 7.73438 1.7107 5.59688 2.06695C2.36719 2.60601 0 5.39976 0 8.67633V8.9482C0 10.8935 0.80625 12.7545 2.23125 14.081Z"
                                                    fill="#DC2626"/>
                                            </svg>
                                        </div>
                                    </div>

                                    <div className={"flex flex-col justify-center"}>
                                        <h2 className={"text-2xl md:text-sm text-[#111827] font-bold leading-8"}>
                                            좋아요 시스템
                                        </h2>
                                        <span className={"text-base md:text-xs text-[#6C7B7F] font-medium leading-6"}>
                                작품과 엽서에 대한 독자들의 반응을 확인하세요!</span>
                                    </div>

                                </div>

                                <div className={"flex justify-between gap-4 bg-[#F5F5F5] rounded-[12px]  p-4 md:p-2 "}>
                                    <div className={"flex flex-row  gap-3 "}>
                                        <div
                                            className="flex justify-center items-center w-[40px] h-[40px]  md:w-7 md:h-7 md:p-[6px] bg-[#EF4444] rounded-full">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16"
                                                 viewBox="0 0 14 16" fill="none" className={"md:w-3 h-3"}>
                                                <g clip-path="url(#clip0_4962_10743)">
                                                    <path
                                                        d="M3 0C1.34375 0 0 1.34375 0 3V13C0 14.6562 1.34375 16 3 16H12H13C13.5531 16 14 15.5531 14 15C14 14.4469 13.5531 14 13 14V12C13.5531 12 14 11.5531 14 11V1C14 0.446875 13.5531 0 13 0H12H3ZM3 12H11V14H3C2.44688 14 2 13.5531 2 13C2 12.4469 2.44688 12 3 12ZM4 4.5C4 4.225 4.225 4 4.5 4H10.5C10.775 4 11 4.225 11 4.5C11 4.775 10.775 5 10.5 5H4.5C4.225 5 4 4.775 4 4.5ZM4.5 6H10.5C10.775 6 11 6.225 11 6.5C11 6.775 10.775 7 10.5 7H4.5C4.225 7 4 6.775 4 6.5C4 6.225 4.225 6 4.5 6Z"
                                                        fill="white"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4962_10743">
                                                        <path d="M0 0H14V16H0V0Z" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>

                                        <div className={"flex flex-col gap-1 justify-center"}>
                                            <span className={"text-[#111827] text-base md:text-sm font-[600]"}>작품</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center justify-center "}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16"
                                             viewBox="0 0 17 16" fill="none" className={"md:w-3 h-3"}>
                                            <g clip-path="url(#clip0_4962_10765)">
                                                <path
                                                    d="M2.15937 9.38767L7.80625 14.6595C8.04063 14.8783 8.35 15.0002 8.67188 15.0002C8.99375 15.0002 9.30313 14.8783 9.5375 14.6595L15.1844 9.38767C16.1344 8.50329 16.6719 7.26267 16.6719 5.96579V5.78454C16.6719 3.60017 15.0938 1.73767 12.9406 1.37829C11.5156 1.14079 10.0656 1.60642 9.04688 2.62517L8.67188 3.00017L8.29688 2.62517C7.27812 1.60642 5.82812 1.14079 4.40313 1.37829C2.25 1.73767 0.671875 3.60017 0.671875 5.78454V5.96579C0.671875 7.26267 1.20937 8.50329 2.15937 9.38767Z"
                                                    fill="#EF4444"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10765">
                                                    <path d="M0.671875 0H16.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span
                                            className={"text-[#DC2626] text-base md:text-xs font-bold leading-6"}>1,247</span>

                                    </div>

                                </div>

                                <div className={"flex justify-between gap-4 bg-[#F5F5F5] rounded-[12px]"}>
                                    <div className={"flex flex-row p-4 gap-3 "}>
                                        <div
                                            className="flex justify-center items-center w-[40px] h-[40px] md:w-7 md:h-7 md:p-[6px] bg-main rounded-full">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                 viewBox="0 0 16 16" fill="none" className={"md:w-3 h-3"}>
                                                <path d="M16 16H0V0H16V16Z" stroke="#E5E7EB"/>
                                                <path
                                                    d="M0 3C0 1.89688 0.896875 1 2 1H14C15.1031 1 16 1.89688 16 3V13C16 14.1031 15.1031 15 14 15H2C0.896875 15 0 14.1031 0 13V3ZM10.1187 6.32812C9.97812 6.12187 9.74687 6 9.5 6C9.25313 6 9.01875 6.12187 8.88125 6.32812L6.1625 10.3156L5.33437 9.28125C5.19062 9.10312 4.975 9 4.75 9C4.525 9 4.30625 9.10312 4.16563 9.28125L2.16563 11.7812C1.98438 12.0063 1.95 12.3156 2.075 12.575C2.2 12.8344 2.4625 13 2.75 13H5.75H6.75H13.25C13.5281 13 13.7844 12.8469 13.9125 12.6C14.0406 12.3531 14.025 12.0562 13.8687 11.8281L10.1187 6.32812ZM3.5 6C3.89782 6 4.27936 5.84196 4.56066 5.56066C4.84196 5.27936 5 4.89782 5 4.5C5 4.10218 4.84196 3.72064 4.56066 3.43934C4.27936 3.15804 3.89782 3 3.5 3C3.10218 3 2.72064 3.15804 2.43934 3.43934C2.15804 3.72064 2 4.10218 2 4.5C2 4.89782 2.15804 5.27936 2.43934 5.56066C2.72064 5.84196 3.10218 6 3.5 6Z"
                                                    fill="white"/>
                                            </svg>
                                        </div>

                                        <div className={"flex flex-col gap-1 justify-center"}>
                                            <span
                                                className={"text-[#111827] text-base md:text-sm  font-[600]"}>엽서</span>
                                        </div>

                                    </div>

                                    <div className={"flex flex-row gap-1 items-center p-4 justify-center"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16"
                                             viewBox="0 0 17 16" fill="none" className={"md:w-3 h-3"}>
                                            <g clip-path="url(#clip0_4962_10765)">
                                                <path
                                                    d="M2.15937 9.38767L7.80625 14.6595C8.04063 14.8783 8.35 15.0002 8.67188 15.0002C8.99375 15.0002 9.30313 14.8783 9.5375 14.6595L15.1844 9.38767C16.1344 8.50329 16.6719 7.26267 16.6719 5.96579V5.78454C16.6719 3.60017 15.0938 1.73767 12.9406 1.37829C11.5156 1.14079 10.0656 1.60642 9.04688 2.62517L8.67188 3.00017L8.29688 2.62517C7.27812 1.60642 5.82812 1.14079 4.40313 1.37829C2.25 1.73767 0.671875 3.60017 0.671875 5.78454V5.96579C0.671875 7.26267 1.20937 8.50329 2.15937 9.38767Z"
                                                    fill="#EF4444"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4962_10765">
                                                    <path d="M0.671875 0H16.6719V16H0.671875V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span
                                            className={"text-[#DC2626] text-base font-bold md:text-xs leading-6"}>389</span>


                                    </div>

                                </div>

                            </div>

                        </motion.div>

                    )


                }


            </section>


            </div>

        </>
    );
};

export default LikeFollowSection;
